import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useB2BTranslation } from "../B2BShared/hooks/useB2BTranslation";
import "./B2BContactPage.css";

const B2BContactPage: React.FC = () => {
  const { t } = useB2BTranslation();

  return (
    <div className="b2b-contact-page">
      <div className="contact-header">
        <Link
          to="/gcb"
          className="back-button"
        >
          <ArrowLeft size={20} />
          {t("contact.backToB2B")}
        </Link>
        <h1>{t("contact.title")}</h1>
      </div>

      <div className="contact-container">
        <div className="contact-content">
          <div className="contact-message">
            <p>
              {t("contact.message")}{" "}
              <a
                href={`mailto:${t("contact.email")}`}
                className="contact-email"
              >
                {t("contact.email")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default B2BContactPage;

